import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import { partners } from "../../../utils/const";
import "./Partners.scss";
import FooterSection from "components/organisms/FooterSection";

const Partners = () => {

  const [partnerList, setPartnerList] = useState({});
  const [combinedPartnerObject, setCombinedPartnerObject] = useState({});

  useEffect(() => {
    async function fetchPartners() {
      try {
        const response = await fetch("https://api-inhousepartner.goodchoiceyourbest.com/api/partner");
        const data = await response.json();
        setPartnerList(data.data);
      } catch (error) {
        console.error("Error fetching partners:", error);
      }
    }
    fetchPartners();
  }, []);

  useEffect(() => {
    const combined = {
        ...partners,
        ...Object.fromEntries(Object.keys(partnerList).map((name) => [name, null])),
    };
    setCombinedPartnerObject(combined);
  }, [partnerList]);

  return (
    <div className="credit-authorization-agreement">
      <Navbar />
      <div className="container-privacy">
        <div className="box-privacy">
          <h2 className="title">Our partners</h2>
          <p class="partner-list">
            {Object.keys(combinedPartnerObject).length > 0 ? (
              Object.keys(combinedPartnerObject).map((partner, index) => (
                <span key={index} className="partner-item">
                  {partner}, {" "}
                </span>
              ))
            ) : (
              <span className="no-partners">No partners available</span>
            )}
          </p>
        </div>
      </div>

      <FooterSection desc={false} />
    </div>
  );
};

export default Partners;
